import { render, staticRenderFns } from "./IntegrationShell.vue?vue&type=template&id=5c9564f3&"
import script from "./IntegrationShell.vue?vue&type=script&lang=js&"
export * from "./IntegrationShell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports